<template>
  <tr>
    <td class="gray">{{ itemData.manager }}</td>
    <td class="blue lighten-3">{{ itemData.firstStage }}</td>
    <td class="blue lighten-3">{{ itemData.secondStage }}</td>
    <td class="blue lighten-3">{{ itemData.thirdStage }}</td>
    <td class="blue lighten-3">{{ itemData.fourthStage }}</td>
    <td class="blue lighten-3">{{ itemData.fifthStage }}</td>
    <td class="blue lighten-3">{{ itemData.sixthStage }}</td>
    <td class="blue lighten-3">{{ itemData.seventhStage }}</td>
    <td class="blue lighten-3">{{ itemData.eighthStage }}</td>
    <td class="yellow lighten-3">{{ itemData.ninthStage }}</td>
    <td class="yellow lighten-3">{{ itemData.tenthStage }}</td>
    <td class="yellow lighten-3">{{ itemData.eleventhStage }}</td>
    <td class="yellow lighten-3">{{ itemData.twelfthStage }}</td>
    <td class="pink lighten-3">{{ itemData.thirdtenStage }}</td>
    <td class="pink lighten-3">{{ itemData.fourtenStage }}</td>
    <td class="pink lighten-3">{{ itemData.fivetenStage }}</td>
    <td class="pink lighten-3">{{ itemData.sixtenStage }}</td>
    <td class="pink lighten-3">{{ itemData.sevenStage }}</td>

    <td class="green">{{ itemData.total }}</td>
  </tr>
</template>

<script>
export default {
  name: "StringTable",
  props:{
    itemData: Object
  },
}
</script>

<style scoped>

</style>